// extracted by mini-css-extract-plugin
export default {"feesTable":"UpdateAdditionalFeesModal_feesTable__8KQIr","compactFeeInput":"UpdateAdditionalFeesModal_compactFeeInput__mnLzu"};